"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const InputText_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/InputText"));
const react_redux_1 = require("react-redux");
const SurveyAdmin_1 = require("../../../actions/SurveyAdmin");
const ReviewCommentForm = ({ interview }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)(['admin', 'main']);
    const dispatch = (0, react_redux_1.useDispatch)();
    const savedReviewComment = (_a = interview.response._validationComment) !== null && _a !== void 0 ? _a : '';
    const [reviewComment, setReviewComment] = (0, react_1.useState)(savedReviewComment);
    (0, react_1.useEffect)(() => {
        var _a;
        setReviewComment((_a = interview.response._validationComment) !== null && _a !== void 0 ? _a : '');
    }, [interview.uuid]);
    const isReviewCommentUnsaved = reviewComment !== savedReviewComment;
    const saveReviewComment = () => {
        if (!isReviewCommentUnsaved) {
            return;
        }
        dispatch((0, SurveyAdmin_1.startUpdateSurveyCorrectedInterview)({
            valuesByPath: {
                'response._validationComment': reviewComment
            }
        }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", { htmlFor: 'reviewComment' }, t('admin:reviewComment')),
        react_1.default.createElement("br", null),
        react_1.default.createElement("div", { className: "admin__review-comment-form" },
            react_1.default.createElement(InputText_1.default, { id: 'reviewComment', rows: 8, value: reviewComment, onValueChange: (event) => {
                    if (event === null || event === void 0 ? void 0 : event.stopPropagation) {
                        event.stopPropagation();
                    }
                    setReviewComment(event.target.value);
                } }),
            isReviewCommentUnsaved && (react_1.default.createElement("button", { type: "button", className: "survey-section__button button blue small", onClick: saveReviewComment }, t('main:Save'))))));
};
exports.default = ReviewCommentForm;
//# sourceMappingURL=ReviewCommentForm.js.map